// Host voice options for the conversational two-host format (Maya / Daniel).
// Every id here is a voice the audio pipeline can synthesize on Google TTS: either a Polly voice
// present in storeuserdata's Polly->Google map, or a Google-native name (Mandarin). Each list is
// curated to voices that map to DISTINCT Google voices so hosts can be told apart.
// Keep in sync with HOST_VOICE_DEFAULTS in scheduledPodcastGenerator/src/index.js.

export const HOST_VOICE_OPTIONS = {
  'en-US': [
    { id: 'Joanna', label: 'Joanna — female', gender: 'female' },
    { id: 'Kendra', label: 'Kendra — female', gender: 'female' },
    { id: 'Kimberly', label: 'Kimberly — female', gender: 'female' },
    { id: 'Matthew', label: 'Matthew — male', gender: 'male' },
    { id: 'Joey', label: 'Joey — male', gender: 'male' },
    { id: 'Justin', label: 'Justin — male', gender: 'male' },
  ],
  'es-ES': [
    { id: 'Lucia', label: 'Lucía — female', gender: 'female' },
    { id: 'Conchita', label: 'Conchita — female', gender: 'female' },
    { id: 'Enrique', label: 'Enrique — male', gender: 'male' },
    { id: 'Sergio', label: 'Sergio — male', gender: 'male' },
  ],
  'es-US': [
    { id: 'Lupe', label: 'Lupe — female', gender: 'female' },
    { id: 'Miguel', label: 'Miguel — male', gender: 'male' },
  ],
  'es-MX': [
    { id: 'Mia', label: 'Mía — female', gender: 'female' },
    { id: 'Andres', label: 'Andrés — male', gender: 'male' },
  ],
  'fr-FR': [
    { id: 'Celine', label: 'Céline — female', gender: 'female' },
    { id: 'Lea', label: 'Léa — female', gender: 'female' },
    { id: 'Mathieu', label: 'Mathieu — male', gender: 'male' },
    { id: 'Remi', label: 'Rémi — male', gender: 'male' },
  ],
  'de-DE': [
    { id: 'Marlene', label: 'Marlene — female', gender: 'female' },
    { id: 'Vicki', label: 'Vicki — female', gender: 'female' },
    { id: 'Hans', label: 'Hans — male', gender: 'male' },
  ],
  'it-IT': [
    { id: 'Carla', label: 'Carla — female', gender: 'female' },
    { id: 'Bianca', label: 'Bianca — female', gender: 'female' },
    { id: 'Giorgio', label: 'Giorgio — male', gender: 'male' },
    { id: 'Adriano', label: 'Adriano — male', gender: 'male' },
  ],
  'pt-BR': [
    { id: 'Camila', label: 'Camila — female', gender: 'female' },
    { id: 'Vitoria', label: 'Vitória — female', gender: 'female' },
    { id: 'Ricardo', label: 'Ricardo — male', gender: 'male' },
  ],
  'zh-CN': [
    { id: 'cmn-CN-Standard-A', label: 'Mandarin female 1', gender: 'female' },
    { id: 'cmn-CN-Standard-D', label: 'Mandarin female 2', gender: 'female' },
    { id: 'cmn-CN-Standard-B', label: 'Mandarin male 1', gender: 'male' },
    { id: 'cmn-CN-Standard-C', label: 'Mandarin male 2', gender: 'male' },
  ],
};

// Defaults must mirror the scheduler's HOST_VOICE_DEFAULTS.
export const HOST_VOICE_DEFAULTS = {
  'en-US': { Maya: 'Joanna', Daniel: 'Matthew' },
  'es-ES': { Maya: 'Lucia', Daniel: 'Enrique' },
  'es-US': { Maya: 'Lupe', Daniel: 'Miguel' },
  'es-MX': { Maya: 'Mia', Daniel: 'Andres' },
  'fr-FR': { Maya: 'Celine', Daniel: 'Mathieu' },
  'de-DE': { Maya: 'Marlene', Daniel: 'Hans' },
  'it-IT': { Maya: 'Carla', Daniel: 'Giorgio' },
  'pt-BR': { Maya: 'Camila', Daniel: 'Ricardo' },
  'zh-CN': { Maya: 'cmn-CN-Standard-A', Daniel: 'cmn-CN-Standard-B' },
};

// Language whose host voices we can pick. Others fall back to the scheduler default silently.
export function hostVoicesSupported(languageCode) {
  return !!HOST_VOICE_OPTIONS[languageCode];
}

// Default host voice for a language/host, or null if unsupported.
export function defaultHostVoice(languageCode, host) {
  return HOST_VOICE_DEFAULTS[languageCode] ? HOST_VOICE_DEFAULTS[languageCode][host] : null;
}
